import LocationMenu from "./location-menu";

export default LocationMenu;